const UrlConstants = {
  base_url: "https://www.clariviz.co",
};

export default UrlConstants;
